import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProductsComponent } from './products/products.component';
import { ServicesComponent } from './services/services.component';
import { CareersComponent } from './careers/careers.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { ProductPOSComponent } from './product-pos/product-pos.component';
import { ProductLotteryComponent } from './product-lottery/product-lottery.component';
import { ProductBankingComponent } from './product-banking/product-banking.component';
import { ProductAccountComponent } from './product-account/product-account.component';
import { AccountPayableComponent } from './account-payable/account-payable.component';
import { ServiceSupportComponent } from './service-support/service-support.component';
import { MarketingComponent } from './marketing/marketing.component';
import { UtilityBillingComponent } from './utility-billing/utility-billing.component';
import { InventoryManagementComponent } from './inventory-management/inventory-management.component';
import { ServiceMobileComponent } from './services/service-mobile/service-mobile.component';
import { ServiceWebComponent } from './services/service-web/service-web.component';
import { ServiceCustomsoftwareComponent } from './services/service-customsoftware/service-customsoftware.component';
import { ServiceCloudsolutionComponent } from './services/service-cloudsolution/service-cloudsolution.component';
import { ServiceTestingComponent } from './services/service-testing/service-testing.component';
import { ServiceDatabasesolutionComponent } from './services/service-databasesolution/service-databasesolution.component';
import { BlogComponent } from './blog/blog.component';
import { BlockchainTechnologyComponent } from './blockchain-technology/blockchain-technology.component';
import { QuantumComputingComponent } from './quantum-computing/quantum-computing.component';
import { WhatIsMobileApplicationComponent } from './what-is-mobile-application/what-is-mobile-application.component';
import { IOSDevelopmentComponent } from './ios-development/ios-development.component';
import { WebAppDevelopmentComponent } from './web-app-development/web-app-development.component';
import { ApplicationDevelopmentProgrammingComponent } from './application-development-programming/application-development-programming.component';
import { DatabaseDevelopmentComponent } from './database-development/database-development.component';
import { SoftwaredevelopmentComponent } from './softwaredevelopment/softwaredevelopment.component';
import { CloudComputingComponent } from './cloud-computing/cloud-computing.component';
import { CustomBuildSoftwareDevelopmentComponent } from './custom-build-software-development/custom-build-software-development.component';
 
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProductsComponent,
    ServicesComponent,
    CareersComponent,
    AboutComponent,
    ContactComponent,
    ProductPOSComponent,
    ProductLotteryComponent,
    ProductBankingComponent,
    ProductAccountComponent,
    AccountPayableComponent,
    ServiceSupportComponent,
    MarketingComponent,
    UtilityBillingComponent,
    InventoryManagementComponent,
    ServiceMobileComponent,
    ServiceWebComponent,
    ServiceCustomsoftwareComponent,
    ServiceCloudsolutionComponent,
    ServiceTestingComponent,
    ServiceDatabasesolutionComponent,
    BlogComponent,
    BlockchainTechnologyComponent,
    QuantumComputingComponent,
    WhatIsMobileApplicationComponent,
    IOSDevelopmentComponent,
    WebAppDevelopmentComponent,
    ApplicationDevelopmentProgrammingComponent,
    DatabaseDevelopmentComponent,
    SoftwaredevelopmentComponent,
    CloudComputingComponent,
    CustomBuildSoftwareDevelopmentComponent 

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
